import { Injectable } from '@angular/core';
import { setupWorker } from 'msw/browser';
import '../../../mocks';

declare var mocks;

@Injectable({
  providedIn: 'root'
})
export class MockService {
  activate() {
    const worker = setupWorker(...mocks);
    worker.start();
  }
}
